class Polygon {
	static get polygon_color() {
		return this._polygon_color || (
			this._polygon_color =
				window
					.getComputedStyle(document.querySelector('body > header'))
					.backgroundColor
		);
	}

	static get default_shape_options() {
		return this._default_shape_options || (this._default_shape_options = {
			clickable: false,
			strokeColor: this.polygon_color,
			fillColor: this.polygon_color
		});
	}

	set clickable(value) {
		this.polygon.setOptions({ clickable: value });
	}

	constructor(
		path, map, {
			id = null,
			hidden_input_container = null,
			hidden_data_input_template = null,
			hidden_id_input_template = null
		} = {}
	) {
		this.polygon = new google.maps.Polygon(
			Object.assign({}, this.constructor.default_shape_options, {
				map: map,
				path: path
			})
		);

		if (!hidden_data_input_template) return;

		this.hidden_data_input = hidden_data_input_template.cloneNode();
		this.hidden_data_input.value = '(' +
			this.polygon.getPath().getArray()
				.map(point => `(${point.lat()},${point.lng()})`)
				.join(',')
			+ ')';
		hidden_input_container.appendChild(this.hidden_data_input);

		if (id) {
			this.hidden_id_input = hidden_id_input_template.cloneNode();
			this.hidden_id_input.value = id;
			hidden_input_container.appendChild(this.hidden_id_input);
		}
	}

	remove() {
		this.polygon.setMap(null);
		this.hidden_data_input.remove();
		if (this.hidden_id_input) {
			this.hidden_id_input.remove();
		}
	}
}

export { Polygon };
